/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-30T11:03:30-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T14:06:24-07:00
*/


import React, { Component } from 'react';
import glamorous, { Div, Span } from 'glamorous';
import Text from '../../common/Text';
import { dimensions, spacing, type, leading, textColor, box, color } from '../../../style'
import Button from '../../blocks/Button';
import BlankSlate from '../../blocks/BlankSlate';
import { Link } from 'react-router';
import { css } from 'glamor';
import { isEmpty } from 'lodash';
import { tsDate, tsDiff, createGoogleMap } from "../../../common";
import { whoPays } from '../../../mt';


const tripMq = '@media (min-width: 1040px)'

const tripRowStyle = css({
  backgroundColor: '#FFF',
  marginBottom: 12,
  display: 'block',
  ...box,
  
  [dimensions.SCREEN_MIN_LG]: {
    display: 'flex',
    justifyContent: 'center'
  }
})


const InfoDiv = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1
});

const Title = glamorous.h2({
  ...spacing.MARGIN_0,
  ...type.title.XS,
  ...leading.TIGHT,
  ...type.NORMAL,
  ...spacing.MARGIN_BOTTOM_SM
});

const DateContainer = glamorous.div({
  // [dimensions.SCREEN_MIN_SM]: {
  //
  // }
});

const ActionsDiv = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginTop: 12,
  
  // [dimensions.SCREEN_MAX_LG]: {
  //   margin: 'auto',
  // }
});

const RowContent = glamorous.div(
  {
    // display: 'flex',
    flex: '1 1 100%',
    padding: 18
  }
)

const RowDetails = glamorous.div(
  {
    display: 'flex',
    flexFlow: 'column',
    
    [tripMq] : {
      flexFlow: 'row'
    }
  },
)

const DestinationImageContainer = glamorous.div({
  flex: '0 0 auto',
  width: 220,
  position: 'relative',

  [dimensions.SCREEN_MAX_LG]: {
    width: '100%'
  }
})

const DestinationImageSpacer = glamorous.div(
  {
    paddingTop: '50%',

    // [dimensions.SCREEN_MAX_LG]: {
    //   paddingTop: '40%',
    // }
  }
)


const DestinationImage = glamorous.div(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  ({src}) => ({
    backgroundImage: `url(${src})`
  })
)

const TripDates = glamorous.div(
  {
    fontSize: 16
    // display: 'flex',
    // justifyContent: 'space-between',
  }
);

const TripDate = glamorous.span({

});

const NumberOfDays = glamorous.div({
  ...textColor.LIGHTER
});

class ProfileTrips extends Component {

  constructor(props) {
    super(props);
    this.renderButton = this.renderButton.bind(this);
  }

  renderButton(trip,key) {
    // only render button if this is not my trip.
    if(Number(trip.account_id) !== Number(this.props.accountId))  {
      if(trip.is_liked === null) {
        // can ask to join
        return (<Button variant="primary" fit onClick={(e) => {e.preventDefault(); this.props.joinTrip(trip.id,key) }}>Ask to join</Button>);
      } else {
        // already asked to join
        return (<Button variant="simple" fit>Asked!</Button>);
      }
    }
  }

  tripList(trips) {
    // loop through each mail item.
    if(!isEmpty(trips)) {
      var TripList = Object.keys(trips).map((key) => {
        let trip = trips[key];
        let arrayKey = `${trip.id}_${trip.account_id}`;
        let dayDiff = tsDiff(trip.leaving_dt.date, trip.returning_dt.date);

        let staticMapImage;
        let staticMapOptions = {
          horizontal: 400,
          vertical: 200,
          scale: 8,
          zoom: 8
        };

        try {
          staticMapImage = createGoogleMap(trip.latitude, trip.longitude, staticMapOptions);
        } catch(e) {
          console.error(e);
        }

        const destinationImage = trip.photo && trip.photo.data && trip.photo.data[0] ? trip.photo.data[0].path : staticMapImage;

        return (
          <Link className={`${tripRowStyle}`} to={`/trip/${trip.id}`} key={arrayKey}>
            <DestinationImageContainer>
              <DestinationImageSpacer />
              <DestinationImage src={destinationImage} />
            </DestinationImageContainer>
                <RowContent>
                  <Title> {trip.city ? `${trip.city},` : ''} {trip.region}, {trip.country}</Title>
                  <RowDetails>
                  <InfoDiv>
                    <DateContainer>
                      <TripDates>
                        <TripDate> {tsDate(trip.leaving_dt.date, 'MMM DD, YYYY')} </TripDate>
                          <Span
                            display="inline-block"
                            padding="0 0.25em"
                            color={color.BRAND_1}
                          >
                            {String.fromCharCode(8594)}
                          </Span>
                        <TripDate> {tsDate(trip.returning_dt.date, 'MMM DD, YYYY')} </TripDate>
                        <Span> {`(${dayDiff})`} </Span>
                      </TripDates>
                    </DateContainer>
                    <Div fontSize={16} marginTop={8}>{whoPays(trip.who_pays)}</Div>
                  </InfoDiv>
                  <ActionsDiv>
                    {this.renderButton(trip,key)}
                  </ActionsDiv>
                </RowDetails>
              </RowContent>
          </Link>
        )

      })
      return <div>
              <h3 className="essay-title title-size4">
                My Trips
              </h3>
              {TripList}
            </div>
    } else {
      return (
        <BlankSlate size='SM' title='They have no planned trips' />
      )
    }
  }

  render() {
    return (<span>
      {this.tripList(this.props.trips)}
    </span>);
  }
}

export default ProfileTrips;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/ProfileTrips.jsx